module.exports = __webpack_public_path__ + "img/bank_content.c237c93f.png";